import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from "@mui/material";
import { useTranslation } from "@/hooks/useTranslation";

const DeleteConfirmDialog = ({ 
    open, 
    title, 
    message, 
    cancelText, 
    confirmText, 
    onCancel, 
    onConfirm 
}) => {
    const { t } = useTranslation();
    
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="delete-dialog-title"
        >
            <DialogTitle id="delete-dialog-title">
                {title || t('common.confirmDelete')}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    {cancelText || t('common.cancel')}
                </Button>
                <Button onClick={onConfirm} color="error" autoFocus>
                    {confirmText || t('common.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialog;